import EzUtils from "@/utils/EzUtils";
import { Constants } from "@/components/Constants";

const DATE_FORMAT_STRING = "dateFormat";
const DATE_FORMAT = "dd MMMM yyyy";
const LOCALE = "locale";
const LOCALE_EN = "en";

export default {
  mapJsonArrayElements(payload, dataTable) {
    let columndata = dataTable.columnHeaderData.filter(columnData =>
      columnData.columnDisplayType == Constants.CODELOOKUP
    );

    columndata.forEach(column => {
      const key = column.columnName.split("_cd_")[1];
      if (payload[column.columnName] != null && payload[key] == null) {
        let code = column.columnValues.filter(code =>
          code.id == payload[column.columnName]
        );
        payload[key] = code[0].value;
        delete payload[column.columnName]
      }
    });

    return payload;
  },

  mapDataTablePayload(payload, dataTable) {
    if (payload == null) {
      return null
    }
    let payloadToBeSent = {};
    payloadToBeSent[DATE_FORMAT_STRING] = DATE_FORMAT
    payloadToBeSent[LOCALE] = LOCALE_EN

    for (let [key, valueObject] of Object.entries(payload)) {
      if (valueObject) {
        dataTable.columnHeaderData && dataTable.columnHeaderData.forEach(columnHeader => {
          if (columnHeader && columnHeader.columnDisplayType) {

            /* Handle Code Lookup */
            if (EzUtils.areEqualString(Constants.CODELOOKUP, columnHeader.columnDisplayType,
              true)) {
              const simpleColumnName = this.getColumnNameWithoutColumnCode(columnHeader.columnName,
                columnHeader.columnCode);

              if (columnHeader.columnCode != null
                && EzUtils.areEqualString(key, simpleColumnName, true)
                && EzUtils.isNotEmpty(columnHeader.columnValues)
              ) {
                columnHeader.columnValues.forEach(columnValue => {
                  if (EzUtils.areEqualString(columnValue.value, valueObject.toString(), true)) {
                    key = columnHeader.columnName;
                    valueObject = columnValue.id;
                  }
                })
              }
            }
          }

          /* Need to handle Date */
          /* Need to handle DateTime */
        })
        payloadToBeSent[key] = valueObject;
      }
    }

    return payloadToBeSent;
  },

  getColumnNameWithoutColumnCode(columnName, columnCode) {
    if ((columnName == null) || (columnCode == null) || !columnName.startsWith(columnCode)) {
      return null
    }

    return columnName.substring(columnName.indexOf(Constants.CODE_VALUE_SEPARATOR) + 4);
  },

  getOptionId(optionsList, name) {
    if (optionsList == null) {
      return -1;
    }
    let code = optionsList.filter(codeValue =>
      codeValue.name == name
    )
    if (code.length > 0) {
      return code[0].id;
    }
    return -1;
  },

  getOptionsList(dataTable, columnCode) {
    let optionsList = [];

    if (dataTable == null || dataTable.columnHeaderData == null || EzUtils.isEmpty(columnCode)) {
      return optionsList;
    }

    dataTable.columnHeaderData && dataTable.columnHeaderData.forEach(columnHeader => {
      if (columnHeader != null
        && EzUtils.areEqualString(Constants.CODELOOKUP, columnHeader.columnDisplayType, true)
        && EzUtils.areEqualString(columnCode, columnHeader.columnCode, true)
        && columnHeader.columnValues != null
      ) {
        columnHeader.columnValues.forEach(columnValue => {
          columnValue && optionsList.push(columnValue.value)
        })
      }
    });
    return optionsList;
  },

  getDocumentTypeId(identifierTypeList, documentType) {
    let documentTypeId = -1;
    if (EzUtils.isEmpty(identifierTypeList)) {
      return documentTypeId;
    }
    let filterIdentiferTypeList = identifierTypeList.filter(identifierType =>
      identifierType.name == documentType
    );
    if(filterIdentiferTypeList && filterIdentiferTypeList[0]){
      documentTypeId = filterIdentiferTypeList[0].id;
    }
    return documentTypeId;
  },

  getOptionName(optionsList, id) {
    if (optionsList == null) {
      return "";
    }
    let code = optionsList.filter(codeValue =>
      codeValue.id == id
    )
    if (code.length > 0) {
      return code[0].name;
    }
    return "";
  },
}
